import { dollarsToNum } from "."
import { LoanApplication } from "./loan-application"
import { LoanCalculations } from "./loan-calculations"
import { IProduct } from "./product"

export type LoanOption = {
  product: IProduct
  payments: { withAutoPay: number, withoutAutoPay: number }
  apr: number
}

export class LoanOptions {
  static for(lapp: LoanApplication, products: IProduct[]): LoanOption[] {
    return products.filter(p => LoanOptions.isEligible(lapp, p)).map(p => {
      const payments = LoanCalculations.paymentsForProduct(
        p,
        dollarsToNum(lapp.loanAmount),
        lapp.installationAddress,
        lapp.projectType
      )

      return {
        product: p,
        payments,
        apr: LoanCalculations.apr(
          dollarsToNum(lapp.loanAmount),
          p.term,
          payments.withAutoPay
        )
      }
    }).filter(o => (
      lapp.maxAllowableMonthlyPayment > 0
        ? o.payments.withAutoPay <= lapp.maxAllowableMonthlyPayment
        : true
    )).sort((a, b) => a.payments.withAutoPay - b.payments.withAutoPay)
  }

  static isEligible(lapp: LoanApplication, p: IProduct): boolean {
    const referenceDate = lapp.createdDate ? new Date(lapp.createdDate) : new Date()
    const typeAndEquipmentMatch = (
      p.productType === lapp.projectType &&
      p.equipmentTypes.includes(lapp.equipmentType || 'standard-solar')
    )

    if (!typeAndEquipmentMatch) return false

    const isEffective = !p.effectiveDate || p.effectiveDate <= referenceDate
    const isNotExpired = !p.expirationDate || p.expirationDate > referenceDate

    let isPrequalEligible = true
    if (p.prequalExpirationDate && lapp.prequalTimestamp) {
      // If product has prequal expiration check if 
      // prequal was received before expiration
      isPrequalEligible = new Date(lapp.prequalTimestamp) <= new Date(p.prequalExpirationDate)
    }

    return isEffective && isNotExpired && isPrequalEligible
  }
}